import { SxProps, Theme } from "@mui/material";
import colorsConstants from "src/app/constants/colors.constants";

const styles = {
  parent: {
    backgroundColor: colorsConstants.mainContentBackgroundColor,
    flex: 1,
    display: "flex",
    height: "100vh",
  },
  drawerAwareContainer: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    padding: "24px",
  },
  titleGrid: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    width: "90%",
    positionAnchor: "revert",
  },
  titleText: {
    color: colorsConstants.primaryText,
    fontSize: 24,
    textAlign: "center",
    flex: 1,
    marginLeft: "24px",
  },
  selectorContainer: {
    width: "100%",
  },
  selectorPaper: {
    p: 2,
    borderRadius: 2,
    border: "1px solid rgba(0, 0, 0, 0.08)",
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
    boxShadow: "none",
  },
  sectionCard: {
    p: 2,
    borderRadius: 2,
    border: "1px solid rgba(0, 0, 0, 0.08)",
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
    boxShadow: "none",
    height: "100%",
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    mb: 2,
  },
  sectionIcon: {
    color: colorsConstants.primaryText,
  },
  sectionTitle: {
    color: colorsConstants.primaryText,
    fontWeight: 700,
  },
  loaderContainer: {
    display: "flex",
    justifyContent: "center",
    py: 4,
  },
  emptyStateText: {
    color: colorsConstants.primaryText,
    opacity: 0.7,
  },
  innerCard: {
    p: 2,
    borderRadius: 2,
    border: "1px solid rgba(0, 0, 0, 0.08)",
    backgroundColor: colorsConstants.mainContentBackgroundColor,
    boxShadow: "none",
  },
  highlightedInnerCard: {
    border: "1px solid rgba(25, 118, 210, 0.45)",
    backgroundColor: "rgba(25, 118, 210, 0.06)",
  },
  priorityInnerCard: {
    border: "1px solid rgba(255, 152, 0, 0.45)",
  },
  itemHeaderRow: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 1,
    mb: 1,
  },
  itemTitleText: {
    color: colorsConstants.primaryText,
    fontWeight: 700,
    mb: 0.5,
    flex: 1,
  },
  itemMetaText: {
    color: colorsConstants.primaryText,
    mb: 0.5,
  },
  itemDescriptionText: {
    color: colorsConstants.primaryText,
    mb: 2,
  },
  itemActionsContainer: {
    display: "flex",
    gap: 1,
    flexWrap: "wrap",
  },
  tagChip: {
    color: "#fff",
    fontWeight: 600,
  },
  paymentAmountText: {
    color: colorsConstants.primaryText,
    fontWeight: 700,
    fontSize: 18,
    mb: 0.5,
  },
  paymentMetaRow: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 1,
  },
  paymentMetaText: {
    color: colorsConstants.primaryText,
    opacity: 0.8,
    fontSize: 14,
  },
  scheduledDueChip: {
    fontWeight: 600,
  },
  logsListContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
  logHeaderRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 1,
    flexWrap: "wrap",
    mb: 1,
  },
  logIdText: {
    color: colorsConstants.primaryText,
    fontWeight: 700,
  },
  logCreatedAtText: {
    color: colorsConstants.primaryText,
    opacity: 0.7,
    fontSize: 14,
    mb: 1,
  },
  logText: {
    color: colorsConstants.primaryText,
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
